import App from '../application.js'

import './setup_i18n'
import 'jquery-validation/dist/localization/messages_zh_TW.js'
import '../vendor/bootstrap-datepicker/locales/bootstrap-datepicker.zh-TW.js'
import 'moment/locale/zh-tw.js'
import './translations.tc.zh-TW.js'

$.fn.datepicker.defaults.language = 'zh-TW'

I18n.defaultLocale = 'zh'
I18n.locale = 'zh-TW'

export default App
